import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DualAuthService } from '../../services/DualAuthService';

@Component({
  selector: 'app-customer-me',
  standalone: true,
  imports: [CommonModule],
  template: `
    <h2>Customer Profile (/api/Customers/me)</h2>
    <pre>{{ data | json }}</pre>
  `,
})
export class CustomerMeComponent implements OnInit {
  data: any;
  private loaded = false;
  constructor(private http: HttpClient, private auth: DualAuthService, private router: Router) {}
  ngOnInit(): void {
    this.auth.currentUser$.subscribe(u => {
      if (!u || this.loaded) return;
      if (!this.auth.isCustomer()) {
        this.router.navigate(['/whoami/employee']);
        return;
      }
      this.loaded = true;
      this.http.get(`${environment.backend.baseUrl}${environment.backend.apiUrl}/Customers/me`, { withCredentials: true })
        .subscribe({ next: d => this.data = d, error: e => this.data = e });
    });
  }
}
